import { CompanyWording } from '@app/models/company/company-wording/company-wording.model';

export const mockCompanyWording: CompanyWording = {
    department: 'Department',
    departmentPlural: 'Departments',
    team: 'Team',
    teamPlural: 'Teams'
}